import Splide from "@splidejs/splide";
import { Grid } from '@splidejs/splide-extension-grid';

import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);


export default function () {
	// const splideId = new Splide('.js-splide-id', {
	// 	direction: 'ttb',
	// 	height: 300,
	// 	perPage: 1,
	// }).mount();

	if (document.querySelector('.istep-box')) {

		function setSvgGradient(id, x1, y1, x2, y2) {
			const element = document.getElementById(id);
			element.setAttribute('x1', x1);
			element.setAttribute('y1', y1);
			element.setAttribute('x2', x2);
			element.setAttribute('y2', y2);
		}

		window.onload = function () {


			let mm;

			function setAnimation() {

				mm = null;

				const istepBox = document.querySelector('.istep-box');
				const istepWrap = document.querySelector('.istep-wrap');

				const istepOne = document.querySelector('.js-step-item-01');
				const istepTwo = document.querySelector('.js-step-item-02');
				const istepFive = document.querySelector('.js-step-item-05');
				const stepItems = document.getElementsByClassName('istep-item');

				mm = gsap.matchMedia();

				mm.add("(min-width: 1101px)", () => {

					$('.istep-svg').attr("viewBox", `0 0 ${istepBox.clientWidth} ${istepBox.clientHeight}`);

					const xAxis = istepWrap.offsetLeft;
					const pathtl = `M0,110 H${xAxis - 140} Q${xAxis} 110 ${xAxis} 270  L${xAxis} ${istepOne.offsetTop + 40}`;
					document.querySelector('.js-istep-pathtl').setAttribute('d', pathtl);
					setSvgGradient('grida', 0, 110, xAxis, istepOne.offsetTop);

					const pathtr = `M${xAxis + 320} 140 Q${xAxis} 180 ${xAxis} ${istepOne.offsetTop + 40}`;
					document.querySelector('.js-istep-pathtr').setAttribute('d', pathtr);
					setSvgGradient('gridb', xAxis, istepOne.offsetTop, xAxis + 360, 180);

					const path2a = `M-100 ${istepTwo.offsetTop - 160} H${xAxis - 160} Q ${xAxis} ${istepTwo.offsetTop - 160} ${xAxis} ${istepTwo.offsetTop}`;
					document.querySelector('.js-istep-patht2a').setAttribute('d', path2a);
					setSvgGradient('gridc', 0, istepTwo.offsetTop - 160, xAxis, istepTwo.offsetTop);

					setSvgGradient('gridd', xAxis, istepOne.offsetTop, xAxis, istepFive.offsetTop + istepFive.offsetHeight);

					for (let i = 0; i < stepItems.length; i++) {
						let path = '';
						if (i < stepItems.length - 1) {
							path = `M${xAxis} ${stepItems[i].offsetTop} V ${stepItems[i + 1].offsetTop + 40}`;
						} else {
							path = `M${xAxis} ${stepItems[i].offsetTop} V ${stepItems[i].offsetTop + stepItems[i].offsetHeight}`;
						}
						document.querySelector('.js-istep-path' + (i + 1)).setAttribute('d', path);

						const len = document.querySelector('.js-istep-path' + (i + 1)).getTotalLength();
						gsap.set('.js-istep-path' + (i + 1), { strokeDasharray: len, strokeDashoffset: len, opacity: 1 })
					}



					const ptlLen = Math.ceil(document.querySelector('.js-istep-pathtl').getTotalLength());
					const ptrLen = Math.ceil(document.querySelector('.js-istep-pathtr').getTotalLength());
					const pt2aLen = Math.ceil(document.querySelector('.js-istep-patht2a').getTotalLength());
					gsap.set('.js-istep-pathtl', { strokeDasharray: ptlLen, strokeDashoffset: ptlLen, opacity: 1 });
					gsap.set('.js-istep-pathtr', { strokeDasharray: ptrLen, strokeDashoffset: ptrLen, opacity: 1 });
					gsap.set('.js-istep-patht2a', { strokeDasharray: pt2aLen, strokeDashoffset: pt2aLen, opacity: 1 });
					gsap.set('.istep-item__ico', { opacity: 0, scale: 0 });

					const tla = gsap.timeline({
						scrollTrigger: {
							trigger: '.js-step-item-01',
							start: 'top 100%',
							end: 'bottom bottom',
							pin: false,
							scrub: true
						}
					});

					tla.to('.js-istep-pathtl', { strokeDashoffset: 0, duration: 1 });
					tla.to('.js-istep-pathtr', { strokeDashoffset: 0, duration: 1 }, "-=.8");
					tla.to('.js-step-item-01 .istep-item__ico', { opacity: 1, scale: 1, duration: .1 });


					for (let i = 1; i < stepItems.length; i++) {
						const tl = gsap.timeline({
							scrollTrigger: {
								trigger: '.js-step-item-0' + (i + 1),
								start: 'top 100%',
								end: 'bottom bottom-=100',
								pin: false,
								scrub: true
							}
						});
						tl.to('.js-istep-path' + i, { strokeDashoffset: 0, duration: 1 });
						if (i === 1) {
							tl.to('.js-istep-patht2a', { strokeDashoffset: 0, duration: 1 }, "-=.8");
						}
						tl.to('.js-step-item-0' + (i + 1) + ' .istep-item__ico', { opacity: 1, scale: 1, duration: .1 });
					}

					const tlb = gsap.timeline({
						scrollTrigger: {
							trigger: '.js-step-item-05',
							start: 'bottom bottom',
							end: 'bottom 75%',
							pin: false,
							scrub: true
						}
					});
					tlb.to('.js-istep-path5', { strokeDashoffset: 0, duration: 1 });
				});

				mm.add("(max-width: 1100px)", () => {
					$('.istep-svg').attr("viewBox", `0 0 ${istepBox.clientWidth} ${istepBox.clientHeight}`);
					const xAxis = istepWrap.offsetLeft + istepWrap.offsetWidth - 8;
					const pathtl = `M0,${istepOne.offsetTop - 100} Q${xAxis} ${istepOne.offsetTop - 100} ${xAxis} ${istepOne.offsetTop + 72}`;
					document.querySelector('.js-istep-pathtl').setAttribute('d', pathtl);
					setSvgGradient('grida', xAxis + 60, istepOne.offsetTop + 60, 0, istepOne.offsetTop - 100);

					const pathtr = `M${xAxis + 60} ${istepOne.offsetTop} Q${xAxis} ${istepOne.offsetTop} ${xAxis} ${istepOne.offsetTop + 72}`;
					document.querySelector('.js-istep-pathtr').setAttribute('d', pathtr);
					setSvgGradient('gridb', xAxis, istepOne.offsetTop + 72, xAxis + 60, istepOne.offsetTop);

					const path2a = `M${xAxis + 60} ${istepTwo.offsetTop - 60} Q ${xAxis} ${istepTwo.offsetTop - 60} ${xAxis} ${istepTwo.offsetTop}`;
					document.querySelector('.js-istep-patht2a').setAttribute('d', path2a);
					setSvgGradient('gridc', xAxis, istepTwo.offsetTop, xAxis + 60, istepTwo.offsetTop - 60);

					setSvgGradient('gridd', xAxis, istepOne.offsetTop, xAxis, istepFive.offsetTop + istepFive.offsetHeight);

					for (let i = 0; i < stepItems.length; i++) {
						let path = '';
						if (i < stepItems.length - 1) {
							path = `M${xAxis} ${stepItems[i].offsetTop + 72} V ${stepItems[i + 1].offsetTop + 80}`;
						} else {
							path = `M${xAxis} ${stepItems[i].offsetTop} V ${stepItems[i].offsetTop + stepItems[i].offsetHeight}`;
						}
						document.querySelector('.js-istep-path' + (i + 1)).setAttribute('d', path);

						const len = document.querySelector('.js-istep-path' + (i + 1)).getTotalLength();
						gsap.set('.js-istep-path' + (i + 1), { strokeDasharray: len, strokeDashoffset: len, opacity: 1 })
					}

					const ptlLen = Math.ceil(document.querySelector('.js-istep-pathtl').getTotalLength());
					const ptrLen = Math.ceil(document.querySelector('.js-istep-pathtr').getTotalLength());
					const pt2aLen = Math.ceil(document.querySelector('.js-istep-patht2a').getTotalLength());
					gsap.set('.js-istep-pathtl', { strokeDasharray: ptlLen, strokeDashoffset: ptlLen, opacity: 1 });
					gsap.set('.js-istep-pathtr', { strokeDasharray: ptrLen, strokeDashoffset: ptrLen, opacity: 1 });
					gsap.set('.js-istep-patht2a', { strokeDasharray: pt2aLen, strokeDashoffset: pt2aLen, opacity: 1 });
					gsap.set('.istep-item__ico', { opacity: 0, scale: 0 });

					const tla = gsap.timeline({
						scrollTrigger: {
							trigger: '.js-step-item-01',
							start: 'top 100%',
							end: 'top 50%',
							pin: false,
							scrub: true
						}
					});

					tla.to('.js-istep-pathtl', { strokeDashoffset: 0, duration: 1 });
					tla.to('.js-istep-pathtr', { strokeDashoffset: 0, duration: 1 }, "-=.8");
					tla.to('.js-step-item-01 .istep-item__ico', { opacity: 1, scale: 1, duration: .1 });


					for (let i = 1; i < stepItems.length; i++) {
						const tl = gsap.timeline({
							scrollTrigger: {
								trigger: '.js-step-item-0' + (i),
								start: 'top 50%',
								end: 'bottom 50%+=80',
								pin: false,
								scrub: true
							}
						});
						tl.to('.js-istep-path' + i, { strokeDashoffset: 0, duration: 1 });
						if (i === 1) {
							tl.to('.js-istep-patht2a', { strokeDashoffset: 0, duration: 1 }, "-=.8");
						}
						tl.to('.js-step-item-0' + (i + 1) + ' .istep-item__ico', { opacity: 1, scale: 1, duration: .1 });
					}

					const tlb = gsap.timeline({
						scrollTrigger: {
							trigger: '.js-step-item-05',
							start: 'top 50%',
							end: 'bottom 75%',
							pin: false,
							scrub: true
						}
					});
					tlb.to('.js-istep-path5', { strokeDashoffset: 0, duration: 1 });


				});

			}

			setAnimation();


			const x = document.querySelector('.istep-item__line').clientWidth - document.querySelector('.js-istep-02-ico').clientWidth;

			gsap.set('.js-istep-02-ico', { x: 0 });
			const tlplane = gsap.timeline({
				scrollTrigger: {
					trigger: '.js-step-item-02',
					start: 'top 50%',
					end: 'top 25%',
					pin: false,
					scrub: true
				}
			});
			tlplane.to('.js-istep-02-ico', { x: x });

		}

	}

	if (document.querySelector('.js-iservice-points')) {
		const ispoints = $('.js-iservice-points');
		setInterval(() => {
			ispoints.toggleClass('active');
		}, 5000);
	}

	if (document.querySelector('.js-splide-istep')) {
		const isteps = document.getElementsByClassName('js-splide-istep');

		for (let i = 0; i < isteps.length; i++) {
			new Splide(isteps[i]).mount();
		}
	}

	if (document.querySelector('.js-splide-icompany')) {
		const splideIcompany = new Splide('.js-splide-icompany', {

		}).mount();
	}

	if (document.querySelector('.js-splide-iplat')) {
		const splideIplat = new Splide('.js-splide-iplat', {
			grid: {
				cols: 6,
				rows: 4,
				gap: {
					row: '30px',
					col: '30px'
				}
			},
			breakpoints: {
				1440: {
					grid: {
						cols: 5,
						gap: {
							row: '20px',
							col: '20px'
						}
					}
				},
				1024: {
					grid: {
						cols: 4,
						gap: {
							row: '20px',
							col: '20px'
						}
					}
				},
				750: {
					grid: {
						cols: 3,
						gap: {
							row: '12px',
							col: '12px'
						}
					}
				}
			}

		}).mount({ Grid });
	}

	if (document.querySelector('.js-splide-inews')) {
		const splideInews = new Splide('.js-splide-inews', {
			breakpoints: {
				1100: {
					type: 'loop',
					focus: 'center',
					autoWidth: true,
					gap: 15,
					perPage: 1,
					perMove: 1
				}
			}
		}).mount();
	}

	if (document.querySelector('.js-index-video')) {
		const video = document.querySelector('.js-index-video').querySelector('video');
		$('.js-index-video').on('click', function () {

			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				video.pause();
			} else {
				$(this).addClass('active');
				video.play();
			}

		});
	}

	if (document.querySelector('.js-ist-msvg')) {
		const pathLen = Math.ceil(document.querySelector('.js-ist-mpath').getTotalLength());

		const pathLen2 = Math.ceil(document.querySelector('.js-ist-mpath2').getTotalLength());

		const tl = new gsap.timeline();
		tl.set('.js-ist-mpath', { strokeDasharray: pathLen, strokeDashoffset: pathLen, opacity: 1 });
		tl.set('.js-ist-mpath2', { strokeDasharray: pathLen2, strokeDashoffset: pathLen2, opacity: 1 });
		tl.set('.index-stsvg-arrow', { opacity: 0, xPercent: -50, yPercent: -25 });

		tl.set('.js-ist-img', { y: 20, opacity: 0 });
		tl.set('.js-ist-intro', { opacity: 0 });

		tl.addLabel('stroke');
		tl.to('.js-ist-mpath', { strokeDashoffset: 0, duration: 1 }, 'stroke');
		tl.to('.js-ist-mpath2', { strokeDashoffset: 0, duration: 1 }, 'stroke');

		tl.to('.index-stsvg-arrow', { opacity: 1, xPercent: 1, yPercent: 1, duration: 1 }, "stroke+=.5");
		tl.to('.js-ist-img', { y: 0, opacity: 1, duration: 1 }, "stroke+=1");
		tl.to('.js-ist-intro', { opacity: 1, duration: 1 }, "stroke+=1.5");
		tl.pause();

		let isPause = true;
		ScrollTrigger.create({
			trigger: '.js-ist-box',
			start: `top 75%`,
			end: 'top 50%',
			markers: false,
			onEnter: ({ progress, direction, isActive }) => {
				if (isPause) {
					isPause = false;
					tl.play();
				}

			}
		});
	}

}